(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("verifyEmail", function () {
        return {
            restrict: "E",
            scope: {},
            templateUrl: "app/public/verifyEmailView.html",
            controllerAs: "vm",
            bindToController: true,
            controller: ["publicResource", "$state", "messageService", VerifyEmailCtrl]
        };
        function VerifyEmailCtrl(publicResource, $state, messageService) {
            var vm = this;
            vm.verifyToken = $state.params.token;
            vm.loading = true;
            publicResource.verifyEmail({ actionValue: vm.verifyToken }, function (result) {
                vm.loading = false;
                if (result.value) {
                    messageService.success("public.verifyEmail.verified");
                    $state.go("main.signIn");
                }
                else {
                    messageService.error("common.error.invalidCode");
                }
            }, function (errorData) {
                messageService.error(errorData);
            });
        }
    });
}());
